import React from "react";
import { connect } from "react-redux";
import { createTurfNote, removeTurfNote } from "../../../store/api/calls/doors";
import { setSessionVar } from "../../../store/actions";
import NoteModal from "./NoteModal";

class TurfNoteModal extends React.Component {
  static defaultProps = {
    categories: [],
    notes: [],
    onCloseModal: () => null,
  };

  constructor(props) {
    super(props);
    this.state = {
      refreshCounter: 0,
    };
  }

  componentWillUnmount() {
    this.props.hideModalAndUnsetTurf();
  }

  onClose = () => {
    this.props.hideModalAndUnsetTurf();
  };

  getNotes = () => {
    return this.props.turf.turfnotes || [];
  };

  getCategories = () => {
    return this.props.categories.filter((d) => d.for_doors);
  };

  getTitle = () => {
    return `Edit Notes for ${this.props.turf.name}`;
  };

  onCreateNote = (category, note) => {
    const creationObj = {
      category,
      note,
      turf_id: this.props.turf.id,
    };

    createTurfNote(creationObj)
      .then((data) => {
        console.log("createTurfNote", data);
        let targetTurf = this.props.turf;

        targetTurf = {
          ...targetTurf,
          turfnotes: [...(targetTurf.turfnotes || []), data],
        };

        this.props.handleNoteCreateOrDestroy(targetTurf);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onRemoveNote = (note_id) => {
    removeTurfNote(note_id).then(() => {
      let targetTurf = this.props.turf;
      targetTurf = {
        ...targetTurf,
        turfnotes: (targetTurf.turfnotes || []).filter((d) => d.id !== note_id),
      };
      this.props.handleNoteCreateOrDestroy(targetTurf);
    });
  };

  render() {
    return (
      <>
        {this.props?.turf?.id && (
          <NoteModal
            {...this.props}
            title={this.getTitle()}
            isOpen={typeof this.props.turf.id !== "undefined"}
            onCloseModal={this.onClose}
            onCreateNote={this.onCreateNote}
            onRemoveNote={this.onRemoveNote}
            notes={this.getNotes()}
            refreshCounter={this.state.refreshCounter}
            loading={this.props.loading}
            categories={this.getCategories()}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  categories: state.siteNotes.categories,
  turf: state.session.vars.turfNoteModalTurf,
  loading: state.siteNotes.loading,
});

const mapDispatchToProps = (dispatch) => ({
  hideModalAndUnsetTurf: () => dispatch(setSessionVar("turfNoteModalTurf", {})), //if set, modal visible. siteObj is null hides modal
});

export default connect(mapStateToProps, mapDispatchToProps)(TurfNoteModal);
